import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useCtxBudgetDrivers } from '../queries/useCtxBudgetDrivers'
import CheckboxGroupFilter from '../../../shared/components/custom/CheckboxGroupFilter'

interface BudgetDriverCheckboxGroupProps {
  value?: number[]
  onChange?: (values: number[]) => void
  placeholder?: string
  checkOnSearch?: boolean
}

const BudgetDriverCheckboxGroup: React.FC<BudgetDriverCheckboxGroupProps> = ({
  value = [],
  onChange,
  placeholder = '',
  checkOnSearch = false
}) => {
  const { t } = useTranslation()
  const { data: budgetDrivers = [], isLoading } = useCtxBudgetDrivers()

  const options = useMemo(() => budgetDrivers.map(d => ({ label: d.name, value: d.formulaId })), [budgetDrivers])

  if (isLoading) {
    return <div style={{ padding: '8px' }}>{t('global:loading')}</div>
  }

  return (
    <CheckboxGroupFilter
      options={options}
      value={value}
      onChange={onChange}
      checkOnSearch={checkOnSearch}
      placeholder={placeholder}
    />
  )
}

export default BudgetDriverCheckboxGroup
